import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=2fe13efa&scoped=true"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"
import style0 from "./reviews.vue?vue&type=style&index=0&id=2fe13efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe13efa",
  null
  
)

export default component.exports